import React, { useEffect } from 'react';
import './CustomAlert.css';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';

const CustomAlert = ({ message, type = 'success', onClose, autoClose = true }) => {
  useEffect(() => {
    if (autoClose) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [autoClose, onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircleIcon className="alert-icon" />;
      case 'error':
        return <ErrorIcon className="alert-icon" />;
      default:
        return <InfoIcon className="alert-icon" />;
    }
  };

  return (
    <div className={`custom-alert ${type}`}>
      <div className="alert-content">
        {getIcon()}
        <div className="alert-message">
          <span className="alert-title">
            {type === 'success' ? 'Başarılı!' : type === 'error' ? 'Hata!' : 'Bilgi'}
          </span>
          <span className="alert-text">{message}</span>
        </div>
      </div>
      <div className="progress-bar"></div>
    </div>
  );
};

export default CustomAlert; 